import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['progressBar'];

  connect() {
    this.boundSetDaysElapsedPosition = this.setDaysElapsedPosition.bind(this);
    this.setDaysElapsedPosition();
    window.addEventListener('resize', this.boundSetDaysElapsedPosition);
  }

  disconnect() {
    window.removeEventListener('resize', this.boundSetDaysElapsedPosition);
  }

  setDaysElapsedPosition() {
    document.documentElement.style.setProperty(
      '--progress-bar-width',
      this.progressBarTarget.offsetWidth + 'px'
    );
  }
}
